<div @fade class="container-signin">

  <div class="right" *ngIf="!stats">
    <div class="right-container">
      <h2 *ngIf="show === '1' || firstInit">{{startMessage}}</h2>
      <h2 *ngIf="show === '3'">¿Has olvidado tu <span class="space-br"><br></span> contraseña?</h2>
    
      <div class="form-container">
        <form autocomplete="off" method="POST" *ngIf="show === '1' && !firstInit" class="form-sign"
          [formGroup]="signForm">
          <div class="input-control-error">
            <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.email.value && signForm.controls.email.invalid &&
              signForm.controls.email.touched || !signForm.controls.email.value && signForm.controls.email.touched}"
              formControlName="email" class="input-search" name="" placeholder="Introduce tu email"
              required="signForm.controls.email.value !== '">
            <div class="div-error"
              *ngIf="signForm.controls.email.value && signForm.controls.email.invalid && signForm.controls.email.touched">
              {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
            </div>
            <div class="div-error" *ngIf="!signForm.controls.email.value && signForm.controls.email.touched"
              [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
            </div>
          </div>
          <div class="input-control-error">
            <div class="see-pass">
              <input type="{{type}}" id="passwordId"
                [ngClass]="{'error-input': !signForm.controls.password.value && signForm.controls.password.touched }"
                formControlName="password" class="input-search" name="" placeholder="Introduce tu contraseña" required>
              <img src="./assets/signin/see_pass.svg" *ngIf="signForm.controls.password.value" (mousedown)="showPass(1)"
                (mouseup)="showPass(2)" alt="">
            </div>
            <div class="div-error" *ngIf="!signForm.controls.password.value && signForm.controls.password.touched"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
            </div>
            <div class="div-error"
              *ngIf="signForm.controls.password.value && signForm.controls.password.touched && signForm.controls.password.invalid"
              [innerHTML]=" 'SIGN.ERRORS.RECOVER_ALL_VALIDATIONS' | translate">
            </div>
          </div>
          <div *ngIf="startMessage !== '¡Bienvenido a Akana!'" class="input-control-error last-input">
            <input type="password" id="passwordTwoId"
              [ngClass]="{'error-input': !signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched }"
              formControlName="passwordTwo" class="input-search" name="" placeholder="Repita la contraseña" required>
            <div class="div-error" *ngIf="!signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
            </div>
            <div class="div-error"
              *ngIf="signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched && squals"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_2_REQUIRED' | translate">
            </div>
          </div>
          <h3 (click)="changeForm('3')" id="forget">¿Has olvidado tu contraseña?</h3>
          <p class="errors" *ngIf="receptionMessage">{{receptionMessage}}</p>
          <button class="sign-in" id="signInId" [ngClass]="{'ready': signForm.valid }" (click)="login(1)"
            *ngIf="!showProgress">{{ buttonName }}</button>
          <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="showProgress"
            mode="indeterminate">
          </mat-progress-bar>
        </form>
        <form autocomplete="off" method="POST" *ngIf="show === '3'" class="form-sign" [formGroup]="signForm">
          <div *ngIf="!receptionMessage">
            <div class="input-control-error recover">
              <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.email.value && signForm.controls.email.invalid &&
              signForm.controls.email.touched || !signForm.controls.email.value && signForm.controls.email.touched}"
                formControlName="email" class="input-search" name="" placeholder="Introduce tu email" required>
              <div class="div-error"
                *ngIf="signForm.controls.email.value && signForm.controls.email.invalid && signForm.controls.email.touched">
                {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
              </div>
              <div class="div-error" *ngIf="!signForm.controls.email.value && signForm.controls.email.touched"
                [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
              </div>
            </div>
            <button class="sign-in" [ngClass]="{'ready': signForm.valid }" (click)="login(3)" *ngIf="!showProgress"
              id="sendId">Enviar</button>
            <mat-progress-bar style="width: 100%; margin: 0; max-width: 350px;" *ngIf="showProgress"
              mode="indeterminate">
            </mat-progress-bar>
          </div>
          <div class="message-sign-up" *ngIf="receptionMessage">
            <p>{{ receptionMessage }}</p>
            <button (click)="changeForm('1')">Volver</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="right" *ngIf="stats">
    <div class="background-container">
      <p>{{ getExpression() }}</p>
      <div class="scoring-container">
        <img class="scoring" src="./assets/global-position/summary/scoring/{{ stats.ScoreNumber }}.svg" alt="">
      </div>
      <p class="kpi" [innerHtml]="getIndebtedness()"></p>
      <p class="kpi" [innerHtml]="getValidAccount()"></p>
    </div>
  </div>
</div>
